import { compose } from 'recompose';
import { withChartLayout, withChartLogic } from 'components/common';
import NeurovascularAssessment from 'components/features/chart/system-assessment/neurovascular-assessment/NeurovascularAssessment';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';

const enhancers = [withChartLayout('Neurovascular Assessment'), withSavedPatientChartsPage, withChartLogic];

const NeurovascularAssessmentPage = compose(...enhancers)(NeurovascularAssessment);
export default NeurovascularAssessmentPage;
